import React from 'react';
import { FadeInUp } from './ui/FadeInUp';
import { SectionEyebrow } from './ui/SectionEyebrow';
import { ArrowRight } from 'lucide-react';
export function IntroSection() {
  return <section className="py-24 md:py-32 bg-ivory" data-id="element-193">
      <div className="container mx-auto px-6" data-id="element-194">
        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24" data-id="element-195">
          <div className="w-full lg:w-1/2" data-id="element-196">
            <FadeInUp data-id="element-197">
              <div className="relative rounded-lg overflow-hidden shadow-2xl aspect-[4/5] max-w-md mx-auto lg:mx-0" data-id="element-198">
                <img src="https://cdn.magicpatterns.com/uploads/wijZpXVNQtbco8qo2i3r35/292174262_540264171123894_3012739179980194327_n.jpg" alt="John & Mickie Beshk" className="w-full h-full object-cover object-top" data-id="element-199" />
                <div className="absolute inset-0 border border-black/5 rounded-lg pointer-events-none" data-id="element-200"></div>
              </div>
            </FadeInUp>
          </div>

          <div className="w-full lg:w-1/2" data-id="element-201">
            <FadeInUp delay={0.1} data-id="element-202">
              <SectionEyebrow text="Meet The Beshk Group" data-id="element-203" />
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-charcoal mb-8 leading-tight text-balance" data-id="element-204">
                A family brokerage, dedicated to making the home buying and
                selling experience better.
              </h2>
              <div className="text-charcoal-text/80 space-y-6 text-lg leading-relaxed mb-10" data-id="element-205">
                <p data-id="element-206">
                  When it comes to buying or selling real estate in the Phoenix
                  Metro area, you want a team of professionals by your side who
                  has over 30 years of experience in the local market.
                </p>
                <p data-id="element-207">
                  John & Mickie Beshk deliver exceptional results whether you
                  are a buyer, seller, landlord, or tenant. Our proven process
                  incorporates modern technology, strategic marketing, honesty,
                  reliability, and professionalism to help you gain an advantage
                  in today's competitive market.
                </p>
              </div>

              <div className="mb-10" data-id="element-208">
                <span className="font-serif text-3xl text-charcoal italic opacity-80" data-id="element-209">
                  John & Mickie Beshk
                </span>
              </div>

              <a href="#" className="inline-flex items-center text-terracotta font-medium group" data-id="element-210">
                Read Our Story
                <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" data-id="element-211" />
                <span className="absolute bottom-0 left-0 w-0 h-px bg-terracotta transition-all group-hover:w-full" data-id="element-212"></span>
              </a>
            </FadeInUp>
          </div>
        </div>
      </div>
    </section>;
}